import { Theme, Font } from '@oneamerica/dxp-ui-components';
import ColorConstants from '../../../../../constants/ColorConstants';

export default () =>
  Theme.Responsive.create({
    placeholderWrapper: {
      minHeight: 24,
      justifyContent: 'center',
      padding:12,
      paddingRight: 20, 
    },
    modalBody: {
      fontFamily: Font.regular.fontFamily,
      fontSize: 16,
      lineHeight: 24,
      color: ColorConstants.iron,
      textAlign: 'left',
      marginBottom: 24,
    },
    buttonsContainer: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      gap: 8,
      flexWrap: 'wrap',
    },
    button: {
      minWidth: 100,
      fontSize: 15,
      fontFamily: Font.medium.fontFamily,
      paddingHorizontal: 12,
    },
     cancelbutton: {
      minWidth: 100,
      fontSize: 15,
      fontFamily: Font.medium.fontFamily,
      paddingHorizontal: 12,
      borderColor:ColorConstants.oaBlue,
    },
    smModalSize: {
      margin: 'auto',
      maxHeight: '70%',
      maxWidth: '90%',
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: 'auto',
      borderRadius: 16,
      overflow: 'hidden',
    },
    mdModalSize: {
      margin: 'auto',
      maxHeight: '80%',
      minWidth: '66.66%',
      maxWidth: '70%',
      borderRadius: 16,
      overflow: 'hidden',
    },
    lgModalSize: {
      marginVertical: 'auto',
      marginHorizontal: 'auto',
      maxHeight: '90%',
      minWidth: '41.66%',
      maxWidth: '50%',
      borderRadius: 16,
      overflow: 'hidden',
    },
  })();
